import React from "react";
import { node, string } from "prop-types";

const propTypes = {
  children: node,
  left: node,
  right: node,
  activeView: string
};

const ActionBar = props => {
  const { children, left, right, activeView } = props;

  return (
    <div className="action-bar">
      <div className="action-bar__content container container--100">
        { activeView !== "map" && <div className="action-bar__left">
          {left}
          {children}
        </div> }

        {right && <div className="action-bar__right">{right}</div>}
      </div>
    </div>
  );
};

ActionBar.propTypes = propTypes;
export default ActionBar;
